import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type CallbackEventParams = {
	eventAction?: EventAction;
	eventName: string;
	componentName?: string;
	value?: string;
};
export class CallbackEvent extends BaseEvent {
	constructor({
		eventName,
		componentName = '',
		eventAction = EventAction.Callback,
		value = '',
	}: CallbackEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName,
			},
			attributes: {
				componentName,
				value,
			},
		});
	}
}
